<div ngbDropdown placement="bottom" class="d-inline-block dropdown-container" [id]="dropdownId()" tabindex="1">
  <div
    class="btn-maplecroft-dropdown dropdown-button d-flex"
    [class.mc-invalid]="invalid()"
    [class.dropdown-button--disabled]="disabled()"
    ngbDropdownToggle
  >
    <p class="quick-search-dropdown-label lh-16">{{ dropdownMessage() }}</p>
    <grid-ui-icon class="mc-dropdown-icon quick-search-dropdown-icon" name="chevron-down"></grid-ui-icon>
  </div>
  <div ngbDropdownMenu>
    @if (countHeader()) {
      <h3 class="mc-dropdown-count-header">
        {{ countHeader() }}
      </h3>
    }
    @if (searchable()) {
      <div #searchInputContainer class="search-container" class="grid-ui-search-input-container" (click)="$event.stopPropagation()">
        <grid-ui-search-input
          [debounce]="debounce()"
          [value]="hint"
          [placeholder]="placeholder()"
          (searchTermChange)="reloadWithHint($event)"
          [attr.data-testid]="'input-' + placeholder() | slugify"
        >
        </grid-ui-search-input>
        <ng-content select="[filter]"></ng-content>
      </div>
    }
    @if (dropdownData().loadingStatus !== RequestStatus.error) {
      <div class="dropdown-menu-body">
        @if (dropdownData().loadingStatus === RequestStatus.loaded && dropdownData().content && dropdownData().content!.items.length > 0) {
          <grid-ui-quick-search-dropdown-results
            #results
            [results]="dropdownData().content!.items"
            (activated)="setActive($event)"
            [activeIndex]="activeIndex"
            (resultSelected)="selectedResultByClick($event)"
          >
          </grid-ui-quick-search-dropdown-results>
        }
        @if (
          dropdownData().loadingStatus === RequestStatus.loaded && (!dropdownData().content || dropdownData().content!.items.length === 0)
        ) {
          <div class="no-matching-results-container">
            <ng-content></ng-content>
          </div>
        }
        @if (dropdownData().loadingStatus === RequestStatus.loading) {
          <grid-ui-loading></grid-ui-loading>
        }
      </div>
    }
    @if (dropdownData().content?.showEntitlementFooter) {
      <grid-ui-additional-countries-offer-footer> </grid-ui-additional-countries-offer-footer>
    }
    @if (dropdownData().loadingStatus === RequestStatus.error && dropdownData().error) {
      <div class="mc-search-results-error">
        <grid-ui-error
          [errorCode]="dropdownData().error!.errorCode"
          [errorMessage]="dropdownData().error!.errorMessage"
          [errorPrimaryAction]="dropdownData().error!.errorPrimaryAction"
          [size]="dropdownData().error!.size"
          (primaryActionClick)="reloadWithHint(hint)"
        >
        </grid-ui-error>
      </div>
    }
  </div>
</div>
